<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    <i class="fas fa-flask mr-2"></i>Simulator Receive Message
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form @submit.prevent="simulateMessage">
                            <!-- Basic Fields (Always Visible) -->
                            <div class="form-group">
                                <label>Device <span class="text-danger">*</span></label>
                                <select v-model="form.device_id" class="form-control" required>
                                    <option value="">Pilih Device</option>
                                    <option v-for="device in devices" :key="device.id" :value="device.device_id">
                                        {{ device.name }} ({{ device.device_id }}) - {{ device.status }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Nomor Pengirim <span class="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    v-model="form.from" 
                                    class="form-control" 
                                    placeholder="6281234567890"
                                    required
                                />
                                <small class="form-text text-muted">Format: 6281234567890 (tanpa +)</small>
                            </div>

                            <div class="form-group">
                                <label>Pesan <span class="text-danger">*</span></label>
                                <textarea 
                                    v-model="form.message" 
                                    class="form-control" 
                                    rows="5"
                                    placeholder="Isi pesan yang akan di-simulate"
                                    required
                                ></textarea>
                            </div>

                            <!-- Advanced Options Toggle -->
                            <div class="form-group">
                                <button 
                                    type="button" 
                                    class="btn btn-link p-0" 
                                    @click="showAdvanced = !showAdvanced"
                                >
                                    <i class="fas" :class="showAdvanced ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    {{ showAdvanced ? 'Sembunyikan' : 'Tampilkan' }} Opsi Lanjutan
                                </button>
                            </div>

                            <!-- Advanced Fields (Hidden by Default) -->
                            <div v-show="showAdvanced" class="advanced-options">
                                <hr class="my-4">
                                <h6 class="mb-3"><i class="fas fa-cog mr-2"></i>Opsi Lanjutan</h6>

                                <div class="form-group">
                                    <label>To (Nomor Penerima)</label>
                                    <input 
                                        type="text" 
                                        v-model="form.to" 
                                        class="form-control" 
                                        placeholder="6281234567890"
                                    />
                                    <small class="form-text text-muted">Diisi jika from_me = true</small>
                                </div>

                                <div class="form-group">
                                    <label>Nama Pengirim</label>
                                    <input 
                                        type="text" 
                                        v-model="form.nama" 
                                        class="form-control" 
                                        placeholder="Nama pengirim"
                                    />
                                </div>

                                <div class="form-group">
                                    <label>Message ID</label>
                                    <input 
                                        type="text" 
                                        v-model="form.message_id" 
                                        class="form-control" 
                                        placeholder="Kosongkan untuk auto-generate"
                                    />
                                    <small class="form-text text-muted">Kosongkan untuk auto-generate</small>
                                </div>

                                <div class="form-group">
                                    <label>URL File (Media)</label>
                                    <input 
                                        type="text" 
                                        v-model="form.url_file" 
                                        class="form-control" 
                                        placeholder="https://example.com/image.jpg"
                                    />
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-4">
                                        <div class="form-check">
                                            <input 
                                                type="checkbox" 
                                                v-model="form.from_me" 
                                                class="form-check-input" 
                                                id="from_me"
                                            />
                                            <label class="form-check-label" for="from_me">
                                                From Me (Pesan Keluar)
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <div class="form-check">
                                            <input 
                                                type="checkbox" 
                                                v-model="form.is_group" 
                                                class="form-check-input" 
                                                id="is_group"
                                            />
                                            <label class="form-check-label" for="is_group">
                                                Is Group
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <div class="form-check">
                                            <input 
                                                type="checkbox" 
                                                v-model="form.media" 
                                                class="form-check-input" 
                                                id="media"
                                            />
                                            <label class="form-check-label" for="media">
                                                Media
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="form.is_group" class="form-group">
                                    <label>Group JID</label>
                                    <input 
                                        type="text" 
                                        v-model="form.group_jid" 
                                        class="form-control" 
                                        placeholder="120363123456789012@g.us"
                                    />
                                </div>

                                <div class="form-group">
                                    <div class="form-check">
                                        <input 
                                            type="checkbox" 
                                            v-model="form.is_mentioned_on_group" 
                                            class="form-check-input" 
                                            id="is_mentioned"
                                        />
                                        <label class="form-check-label" for="is_mentioned">
                                            Is Mentioned On Group
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Quoted Message</label>
                                    <input 
                                        type="text" 
                                        v-model="form.quoted_message" 
                                        class="form-control" 
                                        placeholder="Pesan yang di-quote"
                                    />
                                </div>
                            </div>

                            <div class="form-group mt-4">
                                <button 
                                    type="submit" 
                                    class="btn btn-primary" 
                                    :disabled="isSubmitting"
                                >
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    {{ isSubmitting ? 'Mengirim...' : 'Simulate Message' }}
                                </button>
                                <button 
                                    type="button" 
                                    class="btn btn-secondary ml-2" 
                                    @click="resetForm"
                                >
                                    <i class="fas fa-redo mr-2"></i>Reset
                                </button>
                            </div>

                            <div v-if="response" class="alert" :class="response.success ? 'alert-success' : 'alert-danger'">
                                <strong>{{ response.success ? 'Success!' : 'Error!' }}</strong>
                                {{ response.message }}
                                <div v-if="response.data" class="mt-2">
                                    <small>Device ID: {{ response.data.device_id }}</small><br>
                                    <small v-if="response.data.message_id">Message ID: {{ response.data.message_id }}</small>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            devices: [],
            isLoading: true,
            isSubmitting: false,
            showAdvanced: false,
            form: {
                device_id: '',
                from: '',
                to: '',
                message: '',
                nama: '',
                message_id: '',
                url_file: '',
                from_me: false,
                is_group: false,
                media: false,
                group_jid: '',
                is_mentioned_on_group: false,
                quoted_message: ''
            },
            response: null
        }
    },
    mounted() {
        this.loadDevices()
    },
    methods: {
        async loadDevices() {
            this.isLoading = true
            try {
                const response = await axios.get('admin/simulator/devices')
                this.devices = response.data.data.devices || []
            } catch (err) {
                this.$toast.error(err.response?.data?.message || 'Gagal memuat devices')
            } finally {
                this.isLoading = false
            }
        },
        async simulateMessage() {
            this.isSubmitting = true
            this.response = null

            try {
                // Prepare payload - map url_file to match backend expectation
                const payload = {
                    device_id: this.form.device_id,
                    from: this.form.from,
                    to: this.form.to || '',
                    message: this.form.message,
                    nama: this.form.nama || '',
                    message_id: this.form.message_id || '',
                    url_file: this.form.url_file || '', // Backend expects url_file in JSON
                    from_me: this.form.from_me,
                    is_group: this.form.is_group,
                    media: this.form.media,
                    group_jid: this.form.group_jid || '',
                    is_mentioned_on_group: this.form.is_mentioned_on_group,
                    quoted_message: this.form.quoted_message || null,
                    token: '', // Will be set by backend
                    quota_webhook_media: 0
                }

                const response = await axios.post('admin/simulator/receive', payload)
                this.response = {
                    success: true,
                    message: response.data.message || 'Message simulated successfully',
                    data: response.data.data || {}
                }
                this.$toast.success('Message simulated successfully')
            } catch (err) {
                this.response = {
                    success: false,
                    message: err.response?.data?.message || 'Gagal simulate message',
                    data: null
                }
                this.$toast.error(err.response?.data?.message || 'Gagal simulate message')
            } finally {
                this.isSubmitting = false
            }
        },
        resetForm() {
            this.form = {
                device_id: '',
                from: '',
                to: '',
                message: '',
                nama: '',
                message_id: '',
                url_file: '',
                from_me: false,
                is_group: false,
                media: false,
                group_jid: '',
                is_mentioned_on_group: false,
                quoted_message: ''
            }
            this.showAdvanced = false
            this.response = null
        }
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 1.5rem;
}

.form-check {
    padding-top: 0.5rem;
}

.alert {
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 0.25rem;
}

.advanced-options {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.btn-link {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
}

.btn-link:hover {
    color: #0056b3;
    text-decoration: underline;
}
</style>

